import {
  MemberProfileTab,
  CompanyProfileTab,
  ProjectProfileTab,
} from "@router/route-params";
import {
  AdmPlan,
  BaseCompanyGroupIdProps,
  BaseCompanyIdProps,
  BaseMemberIdProps,
  BaseProjectIdProps,
} from "@custom-types/base-types";
import { PreservedSearchProps } from "@hooks/use-preserved-search";

/** Name of different paths in the app  */
export enum EAppRoutes {
  HomePage = "HomePage",
  CompanyRoute = "CompanyRoute",
  CompanyAddPlanRoute = "CompanyAddPlanRoute",
  CompanyAddFeatureRoute = "CompanyAddFeatureRoute",
  CompanyAddDevicePlanRoute = "CompanyAddDevicePlanRoute",
  CompanyCopyPlanRoute = "CompanyCopyPlanRoute",
  CompanyAddProjectRoute = "CompanyAddProjectRoute",
  ProjectRoute = "ProjectRoute",
  ProjectAddPlanRoute = "ProjectAddPlanRoute",
  ProjectAddFeatureRoute = "ProjectAddFeatureRoute",
  ProjectCopyPlanRoute = "ProjectCopyPlanRoute",
  MemberRoute = "MemberRoute",
  AboutProductsRoute = "AboutProductsRoute",
  TestingImpersonationRoute = "TestingImpersonationRoute",
}

export interface GenerateRouteReturn {
  generateHomeRoute: () => PreservedSearchProps;

  generateCompanyRoute: ({
    companyId,
    companyProfileTab,
  }: BaseCompanyIdProps & {
    companyProfileTab?: CompanyProfileTab;
  }) => PreservedSearchProps;

  generateCompanyAddPlanRoute: ({
    companyId,
  }: BaseCompanyIdProps) => PreservedSearchProps;

  generateCompanyAddFeatureRoute: ({
    companyId,
  }: BaseCompanyIdProps) => PreservedSearchProps;

  generateCompanyAddDevicePlanRoute: ({
    companyId,
  }: BaseCompanyIdProps) => PreservedSearchProps;

  generateCompanyCopyPlanRoute: ({
    companyId,
    planId,
  }: BaseCompanyIdProps & { planId: AdmPlan["id"] }) => PreservedSearchProps;

  generateCompanyAddProjectPlanRoute: ({
    companyId,
    groupId,
  }: BaseCompanyGroupIdProps) => PreservedSearchProps;

  generateProjectRoute: ({
    projectId,
    projectProfileTab,
  }: BaseProjectIdProps & {
    projectProfileTab?: ProjectProfileTab;
  }) => PreservedSearchProps;

  generateProjectAddPlanRoute: ({
    projectId,
  }: BaseProjectIdProps) => PreservedSearchProps;

  generateProjectAddFeatureRoute: ({
    projectId,
  }: BaseProjectIdProps) => PreservedSearchProps;

  generateProjectCopyPlanRoute: ({
    projectId,
    planId,
  }: BaseProjectIdProps & { planId: AdmPlan["id"] }) => PreservedSearchProps;

  generateMemberRoute: ({
    memberId,
    memberProfileTab,
  }: BaseMemberIdProps & {
    memberProfileTab?: MemberProfileTab;
  }) => PreservedSearchProps;

  generateAboutProductsRoute: () => PreservedSearchProps;

  generateTestingImpersonationRoute: () => PreservedSearchProps;
}
